import React from "react";
// import { bindActionCreators } from "redux"
import { connect } from "react-redux";
// import bind from "memoize-bind"

import CSSModules from "lib/utils/css-modules";
// import { rejectOrderWithConfirm, approveOrderWithConfirm } from "modules/customers/utils"
import AgentCooperationsListItem from "./AgentCooperationsListItem";
import styles from "./List.less";

@connect(
  (state) => ({
    currentCompanyId: state.auth.company.model.id,
    // customerActionPendingById: state.customers.utils.customerActionPendingById,
  })
  // dispatch => bindActionCreators({
  //   rejectOrderWithConfirm,
  //   approveOrderWithConfirm,
  // }, dispatch)
)
@CSSModules(styles)
export default class AgentCooperationsList extends React.PureComponent {
  render() {
    const { records, currentCompanyId, ...rest } = this.props;
    return (
      <div styleName="list">
        {records.map((record) => (
          <AgentCooperationsListItem key={record.id} record={record} currentCompanyId={currentCompanyId} {...rest} />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/AgentCooperationsList.jsx